<template>
    <div class="send-redirect-box">
    </div>
</template>
  
<script>
import axios from "axios";
  
export default {
    name: "SendRedirect",
    data() {
      return {
        src: ""
      };
    },
    mounted() {
      this.loadData();
      this.$emit('closeActionDialog', true); // 关闭弹框
    },
    methods: {
      loadData() {
        const { tableName, tableId, itemId } = this.$router.currentRoute.params;
        const { webid, webname } = this.$attrs['obj-tab-action-dialog-config'];
        
        const tableMap = {
            '249130100': '249130069',
            '249130182': '249130069',
            '249130183': '249130069',
            '249130185': '249130069',
            '249130190': '249130069',
            '249130229': '249130069',
            '249130233': '249130069',
            '249130245': '249130069',
            '249130318': '249130069',
            '249130319': '249130069',
            '249130320': '249130069',
            '249130338': '249130069',
            '249130533': '249130069',
            '249130300': '249130078',
            '249130301': '249130078',
            '249130302': '249130078',
            '249130303': '249130078',
            '249130220': '249130082',
            '249130221': '249130082',
            '249130222': '249130082',
            '249130223': '249130082',
            '249130248': '249130082',
            '249130249': '249130082',
            '249130250': '249130082',
            '249130251': '249130082',
            '249130253': '249130082',
            '249130605': '249130082',
            '249130247': '249130089',
            '249130254': '249130089',
            '249130255': '249130089',
            '249130257': '249130089',
            '249130321': '249130108',
            '249130292': '249130122',
            '249130293': '249130122',
            '249130294': '249130122',
            '249130295': '249130122',
            '249130333': '249130163',
            '249130443': '249130163',
            '249130551': '249130166',
            '249130339': '249130169',
            '249130340': '249130169',
            '249130341': '249130169',
            '249130342': '249130169',
            '249130506': '249130169',
            '249130508': '249130169',
            '249130509': '249130169',
            '249130510': '249130169',
            '249130522': '249130169',
            '249130523': '249130522',
            '249130524': '249130169',
            '249130525': '249130169',
            '249130526': '249130169',
            '249130284': '249130170',
            '249130285': '249130170',
            '249130286': '249130170',
            '249130287': '249130170',
            '249130617': '249130170',
            '249130625': '249130170',
            '249130626': '249130170',
            '249130627': '249130628',
            '249130628': '249130170',
            '249130394': '249130171',
            '249130395': '249130171',
            '249130396': '249130171',
            '249130397': '249130171',
            '249130316': '249130173',
            '249130534': '249130173',
            '249130535': '249130173',
            '249130337': '249130277',
            '249130516': '249130476',
            '249130517': '249130476',
            '249130520': '249130476',
            '249130521': '249130476',
            '249130642': '249130640',
            '249130585': '249130583',
            '249130642': '249130640' 
        };
        //虚：实
        console.log('tableId :>> ', tableMap[tableId]);
        
        let param = {
            userId: this.$store.state.global.userInfo.id,
            itemId: itemId,
            tableId: tableMap[tableId] ? tableMap[tableId] : tableId,
            actionId : webid,
			actionName : webname
        };
  
        axios({
            url: "/p/cs/sendRedirect/doAction",
            method: "post",
            data: param,
        }).then((res) => {
            console.log("res :>> ", res);
            // 没有data创建一个错误的消息
            let resData = res.data || {data : {code : 999}};
            if (res.status != 200 || resData.data.code != 0) {
                let msg = resData.data.message || "请求失败，请重新尝试！";
                this.$emit('closeActionDialog', true); // 关闭弹框
                this.$Modal.fcError({
                    title: "提示",
                    content: msg
                });
            }
            
            let targetUrl = resData.data.url;
            console.log("targetUrl :>> ", targetUrl);
            window.open(targetUrl, '_blank');
        });
      }
    }
};
</script>